<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.loggedAction"
                          :label="labels.loggedAction"
                          :error-messages="errors.collect('loggedAction')"
                          data-vv-name="loggedAction"
                          :data-vv-as="labels.loggedAction"
                          data-vv-scope="filters"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.loggedUser"
                          :label="labels.loggedUser"
                          :error-messages="errors.collect('loggedUser')"
                          data-vv-name="loggedUser"
                          :data-vv-as="labels.loggedUser"
                          data-vv-scope="filters"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.loggedHost"
                          :label="labels.loggedHost"
                          :error-messages="errors.collect('loggedHost')"
                          data-vv-name="loggedHost"
                          :data-vv-as="labels.userId"
                          data-vv-scope="filters"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="filters.dateLoggedFrom"
                          :label="labels.dateLoggedFrom"
                          :data-vv-as="labels.dateLoggedFrom"
                          data-vv-name="dateLoggedFrom"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="filters.dateLoggedTo"
                          :label="labels.dateLoggedTo"
                          :data-vv-as="labels.dateLoggedTo"
                          data-vv-name="dateLoggedTo"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
        <v-card>
          <!-- <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
            <template v-slot:item="row">
              <td class="text-xs-left">{{ row.item.auditId }}</td>
              <td class="text-xs-left">{{ row.item.loggedAction }}</td>
              <td class="text-xs-left">{{ row.item.loggedUser }}</td>
              <td class="text-xs-left">{{ row.item.loggedHost }}</td>
              <td class="text-xs-left">{{ row.item.loggedDuration }}</td>
              <td class="text-xs-left">{{formatDisplayDateTime(row.item.loggedDate)}}</td>
              <td class="text-right">
                 <v-tooltip bottom>
                  <v-btn text icon color="info" v-on="on" @click="showDetailsDialog(row.item)" class="tableActionBtn">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <span>Show Details</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table> -->
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :server-items-length="totalItems"
            :no-data-text="noDataText"
            v-bind:options.sync="pagination"
          >
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.auditId }}</td>
                <td class="text-xs-left">{{ row.item.loggedAction }}</td>
                <td class="text-xs-left">{{ row.item.loggedUser }}</td>
                <td class="text-xs-left">{{ row.item.loggedHost }}</td>
                <td class="text-xs-left">{{ row.item.loggedDuration }}</td>
                <td class="text-xs-left">{{ formatDisplayDateTime(row.item.loggedDate) }}</td>
                <td class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn text icon v-on="on" color="info" @click="showDetailsDialog(row.item)" class="tableActionBtn">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>Show Details</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="auditLogDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>Audit Log Details</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div v-if="selectedAuditLog" class="pb-3">
            {{ selectedAuditLog.loggedDetails }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="auditLogDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate2, formatDisplayDateTime, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      init: 0,
      jobs: [],
      menu: {},
      selectedAuditLog: undefined,
      auditLogDialog: false,
      totalItems: 0,
      headers: [
        { text: 'Audit Id', value: 'auditId' },
        { text: 'Logged Action', value: 'loggedAction' },
        { text: 'Logged User ', value: 'loggedUser' },
        { text: 'Host', value: 'loggedHost' },
        { text: 'Duration (secs)', value: 'loggedDuration' },
        { text: 'Logged Date', value: 'loggedDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        loggedAction: 'Logged Action',
        loggedUser: 'Logged User',
        loggedHost: 'Host',
        dateLoggedFrom: 'Logged Date From',
        dateLoggedTo: 'Logged Date To'
      },
      filters: {
        loggedAction: null,
        loggedUser: null,
        loggedHost: null,
        dateLoggedFrom: null,
        dateLoggedTo: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.app.menu.auditLog
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
            this.fetchAuditLogs()
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchAuditLogs(options) {
      this.init = 0
      const apiURI = this.menu.auditLogList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.dateLoggedFrom !== null && massageFilters.dateLoggedFrom !== '') {
            massageFilters.dateLoggedFrom = formatDisplayDateTime2(removeTime(massageFilters.dateLoggedFrom))
          }
          if (massageFilters.dateLoggedTo !== null && massageFilters.dateLoggedTo !== '') {
            massageFilters.dateLoggedTo = formatDisplayDateTime2(removeTime(massageFilters.dateLoggedTo))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            const { data } = result
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              this.$set(this, 'items', data.data)
            }
          }
          this.init = 1
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.init = 2
          this.loading = false
        }
      }
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate2(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    showDetailsDialog(audit) {
      this.selectedAuditLog = audit
      this.auditLogDialog = true
    },
    doFilters() {
      this.$validator.validateAll('filters').then((result) => {
        if (result) {
          this.fetchAuditLogs(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.loggedAction = null
      this.filters.loggedUser = null
      this.filters.loggedHost = null
      this.filters.dateLoggedFrom = null
      this.filters.dateLoggedTo = null
      this.fetchAuditLogs(false)
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchAuditLogs(false)
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
